import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

const STORAGE_KEY = 'lastViewedTopicId'

export function getLastViewedTopicId(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

export function setLastViewedTopicId(id: string | number): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(id))
  } catch (e) {
    void e
  }
}

export function useActiveTopic(): { topicId: string | null } {
  const { topicId = null } = useParams<{ topicId: string }>()

  useEffect(() => {
    if (topicId) {
      setLastViewedTopicId(topicId)
    }
  }, [topicId])

  return { topicId }
}
